import React from "react";
import { Navigate } from "react-router-dom";

// Pages Component
import Chat from "../pages/Chat/Chat";

// File Manager
import FileManager from "../pages/FileManager/index";

// Profile
import UserProfile from "../pages/Authentication/user-profile";
import Profile from "../pages/Authentication/Profile";

// Pages Calendar
//import Calendar from "../pages/Calendar/index";

// //Tasks
import TasksList from "../pages/Tasks/tasks-list";
import TasksCreate from "../pages/Tasks/tasks-create";
import TasksKanban from "../pages/Tasks/tasks-kanban";

// //Projects
import ProjectsGrid from "../pages/Projects/projects-grid";
import ProjectsList from "../pages/Projects/projects-list";
import ProjectsOverview from "../pages/Projects/ProjectOverview/projects-overview";
import ProjectsCreate from "../pages/Projects/projects-create";

// //Ecommerce Pages
import EcommerceProducts from "../pages/Ecommerce/EcommerceProducts";
import EcommerceProductDetail from "../pages/Ecommerce/EcommerceDetails/index";
import EcommerceOrders from "../pages/Ecommerce/EcommerceOrders/index";
import EcommerceCustomers from "../pages/Ecommerce/EcommerceCustomers/index";
import EcommerceCart from "../pages/Ecommerce/EcommerceCart";
import EcommerceCheckout from "../pages/Ecommerce/EcommerceCheckout";
import EcommerceShops from "../pages/Ecommerce/EcommerceShops/index";
import EcommerceAddProduct from "../pages/Ecommerce/EcommerceAddProduct";

//Email
import EmailInbox from "../pages/Email/email-inbox";
import EmailRead from "../pages/Email/email-read";
import EmailBasicTemplte from "../pages/Email/email-basic-templte";
import EmailAlertTemplte from "../pages/Email/email-template-alert";
import EmailTemplateBilling from "../pages/Email/email-template-billing";

//Invoices
//import InvoicesList from "../pages/Invoices/invoices-list";
//import InvoiceDetail from "../pages/Invoices/invoices-detail";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPassword from "../pages/Authentication/ForgetPassword";
import VerifyForgetPassword from "../pages/Authentication/VerifyForgetPassword";
import Security from "../pages/accounts/security";


//  // Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Login2 from "../pages/AuthenticationInner/Login2";
import Register1 from "../pages/AuthenticationInner/Register";
import Register2 from "../pages/AuthenticationInner/Register2";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import Recoverpw2 from "../pages/AuthenticationInner/Recoverpw2";
import ForgetPwd1 from "../pages/AuthenticationInner/ForgetPassword";
import ForgetPwd2 from "../pages/AuthenticationInner/ForgetPassword2";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";
import LockScreen2 from "../pages/AuthenticationInner/auth-lock-screen-2";
import ConfirmMail from "../pages/AuthenticationInner/page-confirm-mail";
import ConfirmMail2 from "../pages/AuthenticationInner/page-confirm-mail-2";
import EmailVerification from "../pages/AuthenticationInner/auth-email-verification";
import EmailVerification2 from "../pages/AuthenticationInner/auth-email-verification-2";
import TwostepVerification from "../pages/AuthenticationInner/auth-two-step-verification";
import TwostepVerification2 from "../pages/AuthenticationInner/auth-two-step-verification-2";
import TwoFactor from "../pages/AuthenticationInner/TwoFactor";

import AcceptInvitation from "../pages/AuthenticationInner/AcceptInvitation";
import ResetPassword from "../pages/AuthenticationInner/ResetPassword";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
//import DashboardSaas from "../pages/Dashboard-saas/index";
//import DashboardCrypto from "../pages/Dashboard-crypto/index";
//import Blog from "../pages/Dashboard-Blog/index";
//import DashboardJob from "../pages/DashboardJob/index";

//Crypto
import CryptoWallet from "../pages/Crypto/CryptoWallet/crypto-wallet";
import CryptoBuySell from "../pages/Crypto/crypto-buy-sell";
import CryptoExchange from "../pages/Crypto/crypto-exchange";
import CryptoLending from "../pages/Crypto/crypto-lending";
import CryptoOrders from "../pages/Crypto/CryptoOrders/crypto-orders";
import CryptoKYCApplication from "../pages/Crypto/crypto-kyc-application";
import CryptoIcoLanding from "../pages/Crypto/CryptoIcoLanding/index";

// Charts
import ChartApex from "../pages/Charts/Apexcharts";
import ChartjsChart from "../pages/Charts/ChartjsChart";
import EChart from "../pages/Charts/EChart";
import SparklineChart from "../pages/Charts/SparklineChart";
import ChartsKnob from "../pages/Charts/charts-knob";
import ReCharts from "../pages/Charts/ReCharts";

// Maps
import MapsGoogle from "../pages/Maps/MapsGoogle";

//Icons
import IconBoxicons from "../pages/Icons/IconBoxicons";
import IconDripicons from "../pages/Icons/IconDripicons";
import IconMaterialdesign from "../pages/Icons/IconMaterialdesign";
import IconFontawesome from "../pages/Icons/IconFontawesome";

//Tables
import BasicTables from "../pages/Tables/BasicTables";
import DatatableTables from "../pages/Tables/DatatableTables";

//Blog
import BlogList from "../pages/Blog/BlogList/index";
import BlogGrid from "../pages/Blog/BlogGrid/index";
import BlogDetails from "../pages/Blog/BlogDetails";

//Job
import JobGrid from "../pages/JobPages/JobGrid/index";
import JobDetails from "../pages/JobPages/JobDetails";
import JobCategories from "../pages/JobPages/JobCategories";
import JobList from "../pages/JobPages/JobList";
import ApplyJobs from "../pages/JobPages/ApplyJobs/index";
import CandidateList from "../pages/JobPages/CandidateList";
import CandidateOverview from "../pages/JobPages/CandidateOverview";

// 
import Action from "../pages/actions";






// FACULTIES
import Faculty from "../pages/faculties";

// DEPARTMENTS
import Department from "../pages/departments";

// SERVICES
import Service from "../pages/services";

// PROGRAM TYPES
import TrainingType from "../pages/training-types";

// Branches
import Branch from "../pages/branches";

// Roles
import Role from "../pages/roles";

// Accounts
import Account from "../pages/accounts";

// Features
import Feature from "../pages/features/index";

// Role Permissions
import RolePermission from "../pages/role-permissions";

// Permissions
import Permission from "../pages/permissions";




// Invoices
import Invoice from "../pages/invoices";

// Study levels
import StudyLevel from "../pages/study-levels";

// Internship Structures
import InternshipStructure from "../pages/internship-structures";

// Document types
import DocumentType from "../pages/document-types";

// Course units
import CourseUnit from "../pages/course-units";

// Titles
import Title from "../pages/titles";

// Jury members
//import JuryMember from "../pages/jury-members";

// Courses components
import CourseComponent from "../pages/course-components";

// Teachers
import Teacher from "../pages/teachers";

// Pre-registrations
import PreRegistration from "../pages/pre-registrations";

// Students
import Student from "../pages/students";
import CreateOrEditStudent from "../pages/students/CreateOrEditStudent";
import StudentDetails from "../pages/students/partials/student-details";

// Evaluations
import Evaluation from "../pages/evaluations";

// Notations
import Notation from "../pages/notations";

import EvaluationForm from "../pages/evaluations/partials/EvaluationForm";

// Notes
import Note from "../pages/notes";

// Registrations
import Registration from "../pages/registrations";

// Interships
import Internship from "../pages/internships";

// Document requests
import DocumentRequest from "../pages/document-requests";

// Defenses
import Defense from "../pages/defenses";

// Payments
import Payment from "../pages/payments";

// Teachers
import TeacherAssignment from "../pages/teacher-assignments";
// Teachers
import TransferRequest from "../pages/transfer-requests";

// Teachers
import Staff from "../pages/staffs";

// PreRegistration details
import PreRegistrationDetails from "../pages/pre-registrations/partials/pre-registration-details";

// File types
import FileType from "../pages/file-types";

// Prestations
import Prestation from "../pages/prestations";

// Fee types
import FeeType from "../pages/fee-types";

// Feature File types
import FeatureFileType from "../pages/feature-file-types/index";

// Academic years
import AcademicYearList from "../pages/academic-years/AcademicYearList";

// Anonymous exam records
import AnonymousExamRecord from "../pages/anonymous-exam-records/index";

// Average
import Average from '../pages/averages/index';

// Exam results
import ExamResult from '../pages/sessions/ExamResult';

// Pre registration configurations
import PreRegistrationConfiguration from '../pages/pre-registration-configurations/index';


// Sessions
import Session from '../pages/sessions/index';

// Exam rooms
import ExamRoom from '../pages/exam-rooms/index';

// Session examens
import SessionExamList from '../pages/sessions/SessionExamList';

// Exam room assignments
import ExamRoomAssignments from '../pages/exam-rooms/partials/AssignmentsPage';

// Final decisions
import FinalDecision from '../pages/final-decisions/index';
// Final decisions retest list
import RetestCandidateList from '../pages/final-decisions/RetestCandidatesList';

// Academic cycle configs
import AcademicCycleConfigList from '../pages/academic-cycle-configs/AcademicCycleConfigList';

// Semesters
import SemesterList from '../pages/semesters/SemesterList';









// Forms
import FormElements from "../pages/Forms/FormElements";
import FormLayouts from "../pages/Forms/FormLayouts";
import FormAdvanced from "../pages/Forms/FormAdvanced";
import FormEditors from "../pages/Forms/FormEditors";
import FormValidations from "../pages/Forms/FormValidations";
import FormMask from "../pages/Forms/FormMask";
import FormRepeater from "../pages/Forms/FormRepeater";
import FormUpload from "../pages/Forms/FormUpload";
import FormWizard from "../pages/Forms/FormWizard";

//Ui
import UiAlert from "../pages/Ui/UiAlert";
import UiButtons from "../pages/Ui/UiButtons";
import UiCards from "../pages/Ui/UiCards";
import UiCarousel from "../pages/Ui/UiCarousel";
import UiColors from "../pages/Ui/UiColors";
import UiDropdown from "../pages/Ui/UiDropdown";
import UiGeneral from "../pages/Ui/UiGeneral";
import UiGrid from "../pages/Ui/UiGrid";
import UiImages from "../pages/Ui/UiImages";
import UiLightbox from "../pages/Ui/UiLightbox";
import UiModal from "../pages/Ui/UiModal";
import UiProgressbar from "../pages/Ui/UiProgressbar";
import UiTabsAccordions from "../pages/Ui/UiTabsAccordions";
import UiTypography from "../pages/Ui/UiTypography";
import UiVideo from "../pages/Ui/UiVideo";
import UiSessionTimeout from "../pages/Ui/UiSessionTimeout";
import UiRating from "../pages/Ui/UiRating";
import UiRangeSlider from "../pages/Ui/UiRangeSlider";
import UiNotifications from "../pages/Ui/ui-notifications";
import UiOffCanvas from "pages/Ui/UiOffCanvas";
import UiUtilitie from "../pages/Ui/UiUtilitie";
import UiPlaceholders from "../pages/Ui/UiPlaceholders";
import UiToasts from "../pages/Ui/UiToast";

//Pages
import PagesStarter from "../pages/Utility/pages-starter";
import PagesMaintenance from "../pages/Utility/pages-maintenance";
import PagesComingsoon from "../pages/Utility/pages-comingsoon";
import PagesTimeline from "../pages/Utility/pages-timeline";
import PagesFaqs from "../pages/Utility/pages-faqs";
import PagesPricing from "../pages/Utility/pages-pricing";
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";

//Contacts
import ContactsGrid from "../pages/Contacts/contacts-grid";
import ContactsList from "../pages/Contacts/ContactList/contacts-list";
import ContactsProfile from "../pages/Contacts/ContactsProfile/contacts-profile";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  //{ path: "/dashboard-saas", component: <DashboardSaas /> },
 // { path: "/dashboard-crypto", component: <DashboardCrypto /> },
  //{ path: "/blog", component: <Blog /> },
  //{ path: "/dashboard-job", component: <DashboardJob /> },

  //Crypto
  { path: "/crypto-wallet", component: <CryptoWallet /> },
  { path: "/crypto-buy-sell", component: <CryptoBuySell /> },
  { path: "/crypto-exchange", component: <CryptoExchange /> },
  { path: "/crypto-lending", component: <CryptoLending /> },
  { path: "/crypto-orders", component: <CryptoOrders /> },
  { path: "/crypto-kyc-application", component: <CryptoKYCApplication /> },

  //chat
  { path: "/chat", component: <Chat /> },

  //File Manager
  { path: "/apps-filemanager", component: <FileManager /> },

  // //calendar
  //{ path: "/calendar", component: <Calendar /> },

  // //profile
  { path: "/profile", component: <Profile /> },

  //Ecommerce
  { path: "/ecommerce-product-detail/:id", component: <EcommerceProductDetail /> },
  { path: "/ecommerce-products", component: <EcommerceProducts /> },
  { path: "/ecommerce-orders", component: <EcommerceOrders /> },
  { path: "/ecommerce-customers", component: <EcommerceCustomers /> },
  { path: "/ecommerce-cart", component: <EcommerceCart /> },
  { path: "/ecommerce-checkout", component: <EcommerceCheckout /> },
  { path: "/ecommerce-shops", component: <EcommerceShops /> },
  { path: "/ecommerce-add-product", component: <EcommerceAddProduct /> },

  //Email
  { path: "/email-inbox", component: <EmailInbox /> },
  { path: "/email-read/:id?", component: <EmailRead /> },
  { path: "/email-template-basic", component: <EmailBasicTemplte /> },
  { path: "/email-template-alert", component: <EmailAlertTemplte /> },
  { path: "/email-template-billing", component: <EmailTemplateBilling /> },

  //Invoices
  //{ path: "/invoices-list", component: <InvoicesList /> },
  //{ path: "/invoices-detail/:id", component: <InvoiceDetail /> },
  //{ path: "/invoices-detail", component: <InvoiceDetail /> },

  // Tasks
  { path: "/tasks-list", component: <TasksList /> },
  { path: "/tasks-create", component: <TasksCreate /> },
  { path: "/tasks-kanban", component: <TasksKanban /> },

  //Projects
  { path: "/projects-grid", component: <ProjectsGrid /> },
  { path: "/projects-list", component: <ProjectsList /> },
  { path: "/projects-overview", component: <ProjectsOverview /> },
  { path: "/projects-overview/:id", component: <ProjectsOverview /> },
  { path: "/projects-create", component: <ProjectsCreate /> },

  //Blog
  { path: "/blog-list", component: <BlogList /> },
  { path: "/blog-grid", component: <BlogGrid /> },
  { path: "/blog-details", component: <BlogDetails /> },

  //job
  { path: "/job-grid", component: <JobGrid /> },
  { path: "/job-details", component: <JobDetails /> },
  { path: "/job-categories", component: <JobCategories /> },
  { path: "/job-list", component: <JobList /> },
  { path: "/job-apply", component: <ApplyJobs /> },
  { path: "/candidate-list", component: <CandidateList /> },
  { path: "/candidate-overview", component: <CandidateOverview /> },

 
  



  


  
   // Roles
  { path: "/roles", component: <Role /> },

   // Accounts
  { path: "/accounts", component: <Account /> },

  // Features
  { path: "/features", component: <Feature /> },

  // Permissions
  { path: "/permissions", component: <Permission /> },

  // Role permissions
  { path: "/role-permissions", component: <RolePermission /> },

 

 

  // Invoices
  { path: "/invoices", component: <Invoice /> },

  // Security page
  { path: "/account/security-access", component: <Security /> },

  //Actions
  { path: "/actions", component: <Action /> },

   // FACULTIES
  { path: "/faculties", component: <Faculty /> },

   // DEPARTMENTS
  { path: "/departments", component: <Department /> },

  // SERVICES
  { path: "/services", component: <Service /> },

  // TRAINING TYPES
  { path: "/training-types", component: <TrainingType /> },

  //Branchs
  { path: "/branches", component: <Branch /> },

  //Branches
  { path: "/study-levels", component: <StudyLevel /> },

  // Internship Structures
  { path: "/internship-structures", component: <InternshipStructure /> },

  // Document types
  { path: "/document-types", component: <DocumentType /> },

   // Course Units
  { path: "/course-units", component: <CourseUnit /> },

    // Titles
  { path: "/titles", component: <Title /> },

  // Jury members
  //{ path: "/jury-members", component: <JuryMember /> },

  // Courses components
  { path: "/course-components", component: <CourseComponent /> },

  // Teachers
  { path: "/teachers", component: <Teacher /> },

   // Teachers
  { path: "/teacher-assignments", component: <TeacherAssignment /> },

  // Pre-registrations
  { path: "/pre-registrations", component: <PreRegistration /> },
  

// Students
{ path: "/students", component: <Student /> },
{ path: "/student/new", component: <CreateOrEditStudent /> },
{ path: "/student/:uuid/edit", component: <CreateOrEditStudent /> },
{ path: "/student/:uuid/details", component: <StudentDetails /> },
  

  // Evaluations
  { path: "/evaluations", component: <Evaluation /> },

  // Notations
  { path: "/notations", component: <Notation /> },

  { path: "/evaluations/new", component: <EvaluationForm /> },
  { path: "/evaluations/:uuid/edit", component: <EvaluationForm /> },

  // Anonymous exam records
  { path: "/anonymous-exam-records", component: <AnonymousExamRecord /> },

  // Anonymous exam records
  { path: "/anonymous-exam-records/evaluation/:evaluationUuid", component: <AnonymousExamRecord /> },

  // Moyenne
  { path: "/evaluation/:evaluationUuid/average", component: <Average /> },

  // Resultat
  { path: "/session/:sessionUuid/results", component: <ExamResult /> },

  // Resultat
  { path: "/session/:sessionUuid/exam/:examUuid/results", component: <ExamResult /> },

   // Session examen list
  { path: "/session/:sessionUuid/exams", component: <SessionExamList /> },

     // Final decisions
  { path: "/final-decisions/session/:sessionUuid", component: <FinalDecision /> },

      // Final decisions retests
  { path: "/final-decisions/session/:sessionUuid/retest-candidates", component: <RetestCandidateList /> },


   // Notes
  { path: "/notes", component: <Note /> },

   // Registrations
  { path: "/registrations", component: <Registration /> },

   // Interships
  { path: "/internships", component: <Internship /> },

   // Document requests
  { path: "/document-requests", component: <DocumentRequest /> },

  // Defenses
  { path: "/defenses", component: <Defense /> },

  // Payments
  { path: "/payments", component: <Payment /> },

  // Payments
  { path: "/transfer-requests", component: <TransferRequest /> },

  // Payments
  { path: "/staffs", component: <Staff /> },

  // PreRegistration details
  { path: "/pre-registration-details", component: <PreRegistrationDetails /> },
  { path: "/pre-registration/:uuid/details", component: <PreRegistrationDetails /> },

  // File types
  { path: "/file-types", component: <FileType /> },

  // Feature file types
  { path: "/feature-file-types", component: <FeatureFileType /> },

   // Prestations
  { path: "/prestations", component: <Prestation /> },

   // Fee types
  { path: "/fee-types", component: <FeeType /> },

   // Academic years
  { path: "/academic-years", component: <AcademicYearList /> },

    // Pre registration configuration
  { path: "/pre-registration-configurations", component: <PreRegistrationConfiguration /> },

    // Sessions
  { path: "/sessions", component: <Session /> },

    // Exam rooms
  { path: "/exam-rooms", component: <ExamRoom /> },

    // Exam room assignments
  { path: "/exam-room-assignments", component: <ExamRoomAssignments /> },

      // Academic cycle conigs
  { path: "/academic-cycle-configs", component: <AcademicCycleConfigList /> },

        // Semesters
  { path: "/semesters", component: <SemesterList /> },


  




 
 



  // Contacts
  { path: "/contacts-grid", component: <ContactsGrid /> },
  { path: "/contacts-list", component: <ContactsList /> },
  { path: "/contacts-profile", component: <ContactsProfile /> },

  //Charts
  { path: "/apex-charts", component: <ChartApex /> },
  { path: "/chartjs-charts", component: <ChartjsChart /> },
  { path: "/e-charts", component: <EChart /> },
  { path: "/sparkline-charts", component: <SparklineChart /> },
  { path: "/charts-knob", component: <ChartsKnob /> },
  { path: "/re-charts", component: <ReCharts /> },

  // Icons
  { path: "/icons-boxicons", component: <IconBoxicons /> },
  { path: "/icons-dripicons", component: <IconDripicons /> },
  { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
  { path: "/icons-fontawesome", component: <IconFontawesome /> },

  // Tables
  { path: "/tables-basic", component: <BasicTables /> },
  { path: "/tables-datatable", component: <DatatableTables /> },

  // Maps
  { path: "/maps-google", component: <MapsGoogle /> },

  // Forms
  { path: "/form-elements", component: <FormElements /> },
  { path: "/form-layouts", component: <FormLayouts /> },
  { path: "/form-advanced", component: <FormAdvanced /> },
  { path: "/form-editors", component: <FormEditors /> },
  { path: "/form-mask", component: <FormMask /> },
  { path: "/form-repeater", component: <FormRepeater /> },
  { path: "/form-uploads", component: <FormUpload /> },
  { path: "/form-wizard", component: <FormWizard /> },
  { path: "/form-validation", component: <FormValidations /> },

  // Ui
  { path: "/ui-alerts", component: <UiAlert /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-colors", component: <UiColors /> },
  { path: "/ui-dropdowns", component: <UiDropdown /> },
  { path: "/ui-general", component: <UiGeneral /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-lightbox", component: <UiLightbox /> },
  { path: "/ui-modals", component: <UiModal /> },
  { path: "/ui-progressbars", component: <UiProgressbar /> },
  { path: "/ui-tabs-accordions", component: <UiTabsAccordions /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-video", component: <UiVideo /> },
  { path: "/ui-session-timeout", component: <UiSessionTimeout /> },
  { path: "/ui-rating", component: <UiRating /> },
  { path: "/ui-rangeslider", component: <UiRangeSlider /> },
  { path: "/ui-notifications", component: <UiNotifications /> },
  { path: "/ui-offcanvas", component: <UiOffCanvas /> },
  { path: "/ui-utilities", component: <UiUtilitie /> },
  { path: "/ui-placeholders", component: <UiPlaceholders /> },
  { path: "/ui-toasts", component: <UiToasts /> },

  //Utility
  { path: "/pages-starter", component: <PagesStarter /> },
  { path: "/pages-timeline", component: <PagesTimeline /> },
  { path: "/pages-faqs", component: <PagesFaqs /> },
  { path: "/pages-pricing", component: <PagesPricing /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPassword /> },
  { path: "/forgot-password/verify", component: <VerifyForgetPassword /> },
  { path: "/register", component: <Register /> },

  { path: "/pages-maintenance", component: <PagesMaintenance /> },
  { path: "/pages-comingsoon", component: <PagesComingsoon /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },
  { path: "/crypto-ico-landing", component: <CryptoIcoLanding /> },

  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-login-2", component: <Login2 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/pages-register-2", component: <Register2 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/page-recoverpw-2", component: <Recoverpw2 /> },
  { path: "/pages-forgot-pwd", component: <ForgetPwd1 /> },
  { path: "/auth-forgot-pwd-2", component: <ForgetPwd2 /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
  { path: "/auth-lock-screen-2", component: <LockScreen2 /> },
  { path: "/page-confirm-mail", component: <ConfirmMail /> },
  { path: "/page-confirm-mail-2", component: <ConfirmMail2 /> },
  { path: "/auth-email-verification", component: <EmailVerification /> },
  { path: "/auth-email-verification-2", component: <EmailVerification2 /> },
  { path: "/auth-two-step-verification", component: <TwostepVerification /> },
  { path: "/auth-two-step-verification-2", component: <TwostepVerification2 /> },

  { path: "/invitation/accept", component: <AcceptInvitation /> },
  { path: "/password/reset", component: <ResetPassword/> },
  { path: "/two-factor", component: <TwoFactor /> },
];

export { authProtectedRoutes, publicRoutes };
